import { render, staticRenderFns } from "./FinalStep.vue?vue&type=template&id=d535becc&"
import script from "./FinalStep.vue?vue&type=script&lang=ts&"
export * from "./FinalStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports